<template>
  <div class="dropdown-wrapper">
    <div class="row-user d-flex align-center">
      <div class="icon pr-1">
        <img :src="data.imageSrc" v-if="typeof data.imageSrc !== 'undefined'" />
        <div v-if="typeof data.imageSrc === 'undefined'" class="default-avatar-background">
          <PersonIcon class="default-avatar"/>
        </div>
      </div>
      <div class="text">
        <span>{{ data.name }}</span><br/>
        <span class="text-email">{{ data.email }}</span>
      </div>
    </div>
    <div class="d-flex dropdown-item" @click="$emit('edit', data);close();">
      <div class="icon pr-1">
        <PersonIconDark/>
      </div>
      <div class="text">
        <span>{{$t('personDropdown.editProfile')}}</span>
      </div>
    </div>
    <div class="d-flex dropdown-item" @click="$emit('logout', data);close();">
      <div class="icon pr-1">
        <LogOffIcon/>
      </div>
      <div class="text">
        <span>{{$t('personDropdown.logout')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LogOffIcon from "@/components/icons/LogOffIcon";
import PersonIconDark from "@/components/icons/PersonIconDark";
import PersonIcon from "@/components/icons/PersonIcon";

export default {
  name: "PersonDropdown",
  components: {PersonIcon, PersonIconDark, LogOffIcon},
  props: {
    data: {
      id: Number,
      name: String,
      email: String,
      imageSrc: String
    },
    close: Function
  }
}
</script>

<style scoped lang="scss">
.dropdown-wrapper {
  position: relative;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .16);
  font-size: 16px;
  line-height: 20px;
  width: 290px;

  // Shadow
  &::before {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    box-shadow: 0 6px 10px 0 rgba(0,0,0, .75);
    content: '';
    height: 1px;
  }

  .dropdown-item {
    position: relative;
    border-top: 1px solid map-get($grey, 'lighten-4');
    cursor: pointer;
    padding: 24px 16px;
    transition: .2s ease-in-out;

    &:hover {
      color: $primary;
    }

    &.active {
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        background-color: $primary;
        width: 5px;
      }
    }
  }

  .row-user {
    background-color: map-get($grey, 'lighten-4');
    padding: 24px 16px;
    line-height: 17px;

    img {
      border-radius: 50%;
    }
  }

  .icon {
    text-align: center;
    min-width: 48px;

    svg {
      max-width: 16px;
      height: auto;
    }
  }

  .text-email {
    color: #878787;
  }

  .default-avatar-background {
    display: flex;
    align-items: center;
    width: 48px;
    height: 48px;
    background-color: map-get($material-light, 'dividers');
    border-radius: 50%;

    .default-avatar {
      margin: auto;
    }
  }
}
</style>

<style lang="scss">
.dropdown-wrapper {
  .dropdown-item {
    svg .a {
      transition: .2s ease-in-out;
    }

    /* SVG hover color change */
    &:hover {
      .log-off-icon .a {
        fill: $primary;
      }

      .person-icon-dark .a {
        stroke: $primary;
      }
    }
  }
}
</style>
